import React, { useContext } from 'react';
import Text from 'components/common/Text';
import { TextInput } from 'components/common/Input';
import sideImageEng from 'images/SignupStep1.png';
import sideImageHeb from 'images/SignupStep1Heb.png';

import { LabelsContext, ThemeContext } from 'helpers/contexts';
import LoadingButton from 'components/common/LoadingButton';
import { LegalDocuments } from 'components/features/LegalDocuments';
import { ContentContainer, FormContainer, HeadlinesContainer, SideImage } from '../style';
import * as S from './style';
import * as Constant from 'constant';
import { getLanguageFromQueryParams } from 'languages';
import { LANGUAGES } from 'languages/utils';

const sideImageByLanguage = {
  [LANGUAGES.HE]: sideImageHeb,
  [LANGUAGES.EN]: sideImageEng,
};

export function DesktopCredentialPage(props) {
  const { colors } = useContext(ThemeContext);
  const { signUp, global } = useContext(LabelsContext);
  const language = getLanguageFromQueryParams();
  const sideImage = sideImageByLanguage[language] || sideImageEng;

  return (
    <S.CredentialPageContainer>
      <S.SignUpContainer bgColor={colors.white} data-testid="signupPopup">
        <HeadlinesContainer isRtl={props.isRtl}>
          <SideImage src={sideImage} alt="step-1" />
        </HeadlinesContainer>
        <FormContainer marginTop={'59px'}>
          <ContentContainer>
            <S.InputsContainer>
              <S.InputContainer>
                <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.name'}>
                  <TextInput
                    size={Constant.SIZE.large}
                    width={Constant.FULL_LENGTH}
                    value={props.fullName}
                    placeholder={signUp.personalDetails.fullName}
                    variant={Constant.VARIENT.empty}
                    onChange={props.onFullNameChange}
                    autoFocus
                    dataTestId="fullName"
                  />
                </S.InputWrapper>
                {props.fullNameError && (
                  <S.ErrorContainer isRtl={props.isRtl}>
                    <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="fullNameError">
                      {props.fullNameError}
                    </Text>
                  </S.ErrorContainer>
                )}
              </S.InputContainer>
              <S.InputContainer>
                <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.phone'}>
                  <TextInput
                    placeholder={signUp.credentialsPage.telephone}
                    value={props.phoneNumberValue}
                    size={Constant.SIZE.large}
                    onChange={props.onPhoneNumberChange}
                    width={Constant.FULL_LENGTH}
                    type={Constant.TEXT_INPUT_TYPE.telephone}
                    variant={Constant.VARIENT.empty}
                    dataTestId="phone"
                  />
                </S.InputWrapper>
                {props.phoneNumberError && (
                  <S.ErrorContainer isRtl={props.isRtl} top={'38px'}>
                    <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="phoneError">
                      {props.phoneNumberError}
                    </Text>
                  </S.ErrorContainer>
                )}
              </S.InputContainer>
              <S.InputContainer>
                <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.email'}>
                  <TextInput
                    size={Constant.SIZE.large}
                    width={Constant.FULL_LENGTH}
                    value={props.emailValue}
                    placeholder={signUp.credentialsPage.email}
                    type={Constant.TEXT_INPUT_TYPE.email}
                    variant={Constant.VARIENT.empty}
                    onChange={props.onEmailChange}
                    dataTestId="email"
                  />
                </S.InputWrapper>
                {props.emailErr && (
                  <S.ErrorContainer isRtl={props.isRtl}>
                    <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="emailError">
                      {props.emailErr}
                    </Text>
                  </S.ErrorContainer>
                )}
              </S.InputContainer>
              <S.InputContainer>
                <S.InputWrapper borderColor={colors.gray.gray400} data-tid={'signup.firstscreen.password'}>
                  <TextInput
                    size={Constant.SIZE.large}
                    withBorder
                    type={Constant.TEXT_INPUT_TYPE.password}
                    value={props.passwordValue}
                    placeholder={signUp.credentialsPage.password}
                    variant={Constant.VARIENT.empty}
                    onChange={props.onPasswordChange}
                    width={Constant.FULL_LENGTH}
                    dataTestId="password"
                  />
                </S.InputWrapper>
                {props.showPasswordError && (
                  <S.ErrorContainer isRtl={props.isRtl}>
                    <Text size={Constant.SIZE.xxs} color={colors.red.salmon} dataTestId="passwordError">
                      {props.passwordErr}
                    </Text>
                  </S.ErrorContainer>
                )}
              </S.InputContainer>
            </S.InputsContainer>
            <S.ButtonContainer data-tid={'signup.firstscreen.nextbutton'}>
              <LoadingButton
                id={'step1'}
                text={global.next}
                color={Constant.COLOR.dark}
                size={Constant.SIZE.xl}
                rounded
                isLoading={props.isLoading}
                onClick={props.onSubmit}
                width={'87px'}
                dataTestId="next"
              />
            </S.ButtonContainer>
            <LegalDocuments isRtl={props.isRtl} isMobile={false} />
          </ContentContainer>
        </FormContainer>
      </S.SignUpContainer>
      <S.HaveAccountContainer marginTop={'20px;'} data-tid={'signup.firstscreen.login'}>
        <Text color={colors.white} size={Constant.SIZE.small}>
          {signUp.credentialsPage.haveAccount}
        </Text>
        <Text color={colors.white} size={Constant.SIZE.small} underline onClick={props.onLoginClick} dataTestId="haveAccount">
          {signUp.credentialsPage.clickHere}
        </Text>
      </S.HaveAccountContainer>
    </S.CredentialPageContainer>
  );
}

export default DesktopCredentialPage;
